/*Form Submit ajax*/
$('body form.ajaxSubmit').submit(function (event) {
    event.preventDefault(); // Prevent the form from submitting via the browser
    var $form = $(this);
    var $btnSubmit = $form.find('button[type=submit]');
    $btnSubmit.prop('disabled', true);

    for (instance in CKEDITOR.instances) {
        CKEDITOR.instances[instance].updateElement();
    }
    var data = new FormData($form[0]);
    $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: data,
        cache: false,
        contentType: false,
        processData: false,
    }).done(function (response) {
        NotifyClass.ajax(response);
        $btnSubmit.prop('disabled', false);

        let callbackFunction = $form.attr('callbackFunction');
        if(callbackFunction != undefined) window[callbackFunction]($form, response);
    }).fail(function (response) {
        NotifyClass.ajax(response);
        $btnSubmit.prop('disabled', false);
    });
});


//COPY
$(document).on('click', '.btn-copy-text', function () {
    const target = $(this).data('target');
    let value = "";
    switch($(target).prop("tagName").toLowerCase()){
        case 'input':
        case 'textarea':
        case 'select':
            value = $(target).val();
            $(target).select();
            break
        default:
            value = $(target).html();
    }

    // $elem.setSelectionRange(0, 99999); // For mobile devices
    navigator.clipboard.writeText(value);

    $(this).tooltip({
        trigger: 'manual',
        title: 'Copied!'
    }).tooltip('show');
    let $self = $(this);
    setInterval(function(){
        $self.attr('title', '')
        $self.tooltip('dispose');
    }, 1000);

});
